export default class AccessToken {
    id: string
    name: string
    token: string
    issuedAt: Date
    constructor(id: string, name: string, token: string, issuedAt: Date) {
        this.id = id
        this.name = name
        this.token = token
        this.issuedAt = issuedAt
    }
    static unmarshal(json: any): AccessToken | undefined {
        if (!json) {
            return undefined
        }
        var issuedAt = new Date(0)
        issuedAt.setUTCSeconds(json.issued_at)
        return new AccessToken(json.id, json.name, json.token, issuedAt)
    }
}
